import './pin-registration.scss';
import template from './pin-registration.html';

export class PinRegistrationController {
  constructor($log, $mdDialog) {
    'ngInject';
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this._title = '';
    this._activeStep = 1;
    this.validPinCode = null;
    this.outsidePerson = null;
  }

  get title() {
    return this._title;
  }

  set title(title) {
    this._title = title;
  }

  get activeStep() {
    return this._activeStep;
  }

  nextStep() {
    this._activeStep += 1;
  }

  onSuccessValidatePin(result) {
    this.validPinCode = result;
  }

  onSuccessAddOutsidePerson(result) {
    this.outsidePerson = result;
  }

  onUnregisterClick() {
    this.$mdDialog.hide(this.outsidePerson);
  }

  closeDialog() {
    this.$mdDialog.cancel();
  }
}

export const PinRegistration = {
  bindings: {
    student: '<'
  },
  controller: PinRegistrationController,
  template
};
